export default __webpack_public_path__ + "static/media/office1-before2.478e43aa.jpg";